import { extractTokenPayload } from 'utils/token';

// https://jira.mi24.tv/browse/CT-2175
// https://jira.mi24.tv/browse/CT-2267
// FE-only Customer Props
export const CustomerProps = {
  DGUV: {
    ctIds: ['212'],
    homepageUrlText: 'zur Startseite',
    homepageUrlTextBold: ' dguv.de',
    homepageUrl: 'https://www.dguv.de',
  },
  UIT: {
    ctIds: ['197'],
    homepageUrlText: 'Hier geht es zum UniVersum',
    homepageUrlTextBold: null,
    homepageUrl: 'https://universum.apps.union-investment.de/home/start',
  },
  GBA: {
    ctIds: ['136', '323', '317'], // 19, 149: local, 136: QA, 323: Prod(staging), 317: Prod
    lngPostfix: '_gba',
    hasAlternativeAttachmentTab: true,
  },
};

export function getDomainName() {
  return window.location.hostname;
}

export const hideElement = (hide) => {
  if (hide) {
    return { display: 'none' };
  }
  return { display: 'inherit' };
};

/**
 * @param {string} rawParamValue
 */
export function encodeUriParam(rawParamValue) {
  return encodeURIComponent(rawParamValue);
}

/**
 * @param {string} encodedParamValue - value return from encodeUriParam() function
 * @returns {string}
 */
export function decodeUriParam(encodedParamValue, tryLegacy = true) {
  const legacy = tryLegacy ? decodeUriParamOld(encodedParamValue) : undefined;
  const current = decodeUriParamNew(encodedParamValue);

  return legacy || current || encodedParamValue;
}

function decodeUriParamOld(encodedParamValue) {
  // CT-2106 - backward compatibility with old format
  if (encodedParamValue.length % 4 !== 0) {
    // Old encoded string length was always multiple of 4.
    return null;
  }

  let result = '';

  try {
    result = decodeURIComponent(escape(atob(encodedParamValue.replace('%2F', '/'))));
  } catch (error) {
    return null;
  }

  for (let i = 0; i < result.length; i++) {
    if (result.charCodeAt(i) < 32) {
      // assume control characters are not intended to be valid
      return null;
    }
  }

  return result;
}

function decodeUriParamNew(encodedParamValue) {
  try {
    return decodeURIComponent(encodedParamValue);
  } catch (error) {
    return null;
  }
}

export function getUserId() {
  const tokenPayload = extractTokenPayload();

  if (!tokenPayload) {
    return null;
  }

  return tokenPayload.user_id;
}

export function getUserName() {
  const tokenPayload = extractTokenPayload();

  if (!tokenPayload) {
    return null;
  }

  return tokenPayload.full_name.length > 0 ? tokenPayload.full_name : tokenPayload.email;
}

/**
 * @param {*} securitySettings
 * @param {*} displaySettings
 * @param {*} queryParams
 */
export function isParentAllowed(securitySettings, displaySettings, queryParams) {
  // Situation where site have allowed iframe parent configured
  // it becomes iframe only hostname of website
  if (displaySettings.isIframe && !queryParams.baseUrl) {
    return false;
  }

  if (displaySettings.isIframe && queryParams.baseUrl) {
    if (securitySettings.allowedParentDomains.length === 0) {
      return true;
    }

    return (
      !!securitySettings.allowedParentDomains.filter((domain) =>
        queryParams.baseUrl.match(new RegExp(`^.*//${domain}.*$`, 'gi'))
      ).length > 0
    );
  }

  return true;
}
